import React, { useEffect } from "react";
import "./css/homepage.css";
import AppleBadge from "./assets/images/apple-appstore-badge.svg";
import GooglePlayBadge from "./assets/images/googleplay.png";
import Footer from "./components/footer";
import HeaderHomepage from "./components/headerHomepage";
import Header from "./components/header";
import { useLanguage } from "./LanguageContext";
import * as text from "./translation.json";

const HomePage = (props) => {
  const { language } = useLanguage();

  useEffect(() => {
    document.title = "Mapli";
  }, []);

  return (
    <div className='homePageContainer'>
      <HeaderHomepage />

      <div className='homePageMainContainer'>
        <div className='containerInfo'>
          <p className='containerInfoText'>
            {text[language].mainheading1}
            <div className='textHighlight' id='restaurants'>
              {text[language].restaurant}
            </div>
            , {text[language].mainheading2}{" "}
            <div className='textHighlight' id='activities'>
              {text[language].activity}
            </div>{" "}
            {text[language].mainheading3}{" "}
            <div className='textHighlight' id='events'>
              {text[language].event}
            </div>{" "}
            {text[language].mainheading4}{" "}
          </p>
          <div className='textHighlight' id='downloadApp'>
            {text[language].lastnedappen}
          </div>
          <div className='appstoreButtons'>
            <a
              href='https://apps.apple.com/us/app/mapli/id6748616006'
              style={{ cursor: "pointer" }}>
              <img src={AppleBadge} height='40px' style={{ marginRight: 5 }} />
            </a>
            <a
              href='https://play.google.com/store/apps/details?id=com.mapli'
              style={{ cursor: "pointer" }}>
              <img
                src={GooglePlayBadge}
                style={{ marginLeft: 5 }}
                height='39px'
              />
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
